import { Card, Row, Col, Typography, Skeleton, Progress } from "antd";
import { FaUsers, FaClock, FaUserTimes } from "react-icons/fa";
import { FaUserClock, FaUserCheck } from "react-icons/fa6";

const { Text } = Typography;

export function ParticipantesCharts({
  metricas,
  metricasCargadas = true // 🔥 NUEVO: Prop para estado de carga
}) {

  // 🔥 USAR MÉTRICAS DEL BACKEND CON VALORES POR DEFECTO
  const {
    total_participantes = 0,
    total_en_proceso = 0,
    total_verificados = 0,
    total_no_verificados = 0,
    total_no_continua = 0,
    total_cupos = 0
  } = metricas || {};

  // 🔥 SKELETON MIENTRAS CARGA
  if (!metricasCargadas) {
    return (
      <Row gutter={[16, 16]} style={{ marginBottom: 15, display: "flex", flexWrap: "wrap" }}>
        {[1, 2, 3, 4, 5].map((item) => (
          <Col key={item} xs={24} sm={12} md={8} lg flex="20%">
            <Card style={{ borderRadius: 12 }}>
              <Skeleton active paragraph={{ rows: 2 }} />
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  const formatNumber = (value) =>
    new Intl.NumberFormat("es-CO").format(Number(value) || 0);

  const porcentajeRaw =
    total_cupos > 0 ? (total_verificados / total_cupos) * 100 : 0;

  const porcentajeCupos =
    porcentajeRaw < 1
      ? Number(porcentajeRaw.toFixed(2))
      : Math.round(porcentajeRaw);

  const cardFooterStyle = {
    marginTop: 2,
    minHeight: 28, // 🔥 espacio reservado
  };


  const colorProgreso =
    porcentajeCupos < 50
      ? "#faad14" // amarillo
      : porcentajeCupos < 80
        ? "#1890ff" // azul
        : "#52c41a"; // verde


  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 15 }}>
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <Card hoverable style={{ borderRadius: 12 }}>
          <div style={{ textAlign: "center" }}>
            <FaUsers style={{ color: "#0968C6", fontSize: 25, marginRight: 10 }} />
            <Text type="secondary">Total familias</Text>
            <Text style={{ display: "block", fontSize: 30, fontWeight: "bold" }}>
              {formatNumber(total_participantes)}

            </Text>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <Card hoverable style={{ borderRadius: 12 }}>
          <div style={{ textAlign: "center" }}>
            <FaClock style={{ color: "#419df8", fontSize: 25, marginRight: 10 }} />
            <Text>En Proceso</Text>
            <Text style={{ display: "block", fontSize: 30, fontWeight: "bold" }}>
              {formatNumber(total_en_proceso)}

            </Text>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <Card hoverable style={{ borderRadius: 12 }}>
          <div style={{ textAlign: "center" }}>
            <FaUserCheck style={{ color: "#20ac00", fontSize: 25, marginRight: 10 }} />
            <Text>Verificados</Text>
            <Text style={{ display: "block", fontSize: 30, fontWeight: "bold" }}>
              {formatNumber(total_verificados)}

            </Text>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <Card hoverable style={{ borderRadius: 12 }}>
          <div style={{ textAlign: "center" }}>
            <FaUserClock style={{ color: "#838383ff", fontSize: 25, marginRight: 10 }} />
            <Text>No Verificado</Text>
            <Text style={{ display: "block", fontSize: 30, fontWeight: "bold" }}>
              {formatNumber(total_no_verificados)}

            </Text>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <Card hoverable style={{ borderRadius: 12 }}>
          <div style={{ textAlign: "center" }}>
            <FaUserTimes style={{ color: "#d62828", fontSize: 25, marginRight: 10 }} />
            <Text>No Continúa</Text>
            <Text style={{ display: "block", fontSize: 30, fontWeight: "bold" }}>
              {formatNumber(total_no_continua)}

            </Text>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <Card hoverable style={{ borderRadius: 12 }}
          styles={{
            body: {
              paddingBottom: 5,
            },
          }}
        >
          <div style={{ textAlign: "center" }}>
            <FaUserCheck style={{ color: "#20ac00", fontSize: 25, marginBottom: 4 }} />
            <Text>Cupos</Text>
            <Text
              style={{
                display: "block",
                fontSize: 30,
                fontWeight: "bold",
                lineHeight: 1.1,
              }}
            >
              {formatNumber(total_cupos)}
            </Text>

            <div style={cardFooterStyle}>
              <Progress
                percent={porcentajeCupos}
                size="small"
                strokeColor={colorProgreso}
              />
            </div>
          </div>
        </Card>
      </Col>




    </Row>

  );
}